<mat-label class="subHeading"
  >Product<span *ngIf="isRequired" class="star">*</span></mat-label
>
<mat-select #prductSelect class="insurer" multiple formControlName="product">
  <mat-option *ngFor="let product of productList" [value]="product">
    {{ product }}
  </mat-option>
</mat-select>
